import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-fieldset',
    template: `
        <div class="rounded-xl border border-slate-200 bg-white">
            <!-- Header with accent line (overflow-hidden only here) -->
            <div
                class="relative overflow-hidden rounded-ss-xl border-b border-slate-100"
            >
                <div
                    class="absolute bottom-0 top-0 w-1 bg-primary-500 ltr:left-0 rtl:right-0"
                ></div>
                <h3
                    class="px-5 py-3 font-semibold text-slate-800 ltr:pl-8 rtl:pr-8"
                >
                    {{ legend }}
                </h3>
            </div>
            <!-- Content -->
            <div class="p-5">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FieldsetComponent {
    @Input() public legend: string;
}
